'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.init = init;

var _themeCart = require('@shopify/theme-cart');

var _pushCartActions = require('../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _functional = require('../utils/functional');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var _this = this;

  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    items: context.getElements('.' + context.className + '_Item')
  };

  var items = els.items.map(function (el) {
    var itemContext = { context: el };

    return {
      trigger: (0, _functional.getElement)('.' + context.className + '_Update', itemContext),
      input: (0, _functional.getElement)('.' + context.className + '_Input', itemContext),
      key: el.dataset.key,
      setLoading: function setLoading(val) {
        this.trigger.classList.toggle('crt-Product_Update-loading', val);
      }
    };
  });

  items.forEach(function (item) {
    item.trigger.addEventListener('click', function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var lineItem;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                item.setLoading(true);

                _context.next = 4;
                return (0, _themeCart.getItem)(item.key);

              case 4:
                lineItem = _context.sent;
                _context.next = 7;
                return window.store.dispatch(pushCartActions.updateLineItem({
                  lineItem: lineItem,
                  quantity: parseInt(item.input.value, 10)
                }));

              case 7:

                window.location.reload();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  });
}